import { Component, OnInit } from '@angular/core';
import { Invoice } from '../../../../model/invoice';
import { InvoicesService } from '../../../../resources/invoices/invoices.service';
import { Api } from '../../../../core/api';
import { MzToastService } from 'ng2-materialize';

@Component({
  selector:    'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls:   [ './invoices.component.scss' ]
})
export class InvoicesComponent implements OnInit {

  invoices: Invoice[];
  loading = true;
  p = 1;

  constructor(private invoicesService: InvoicesService,
              private toast: MzToastService,
              private api: Api) {
  }

  ngOnInit() {
    this.invoicesService.query()
      .map((res) => res.map((i) => new Invoice(i)))
      .subscribe((res) => {
        this.loading = false;
        this.invoices = res;
      });

  }

  getInvoice(invoice: Invoice) {
    this.api.get('invoice/' + invoice.id, null, { responseType: 'blob' })
      .map((response) => {
        return response;
      })
      .subscribe((x) => {
        const data = URL.createObjectURL(x);
        const link = document.createElement('a');
        link.href = data;
        link.download = `invoice_${invoice.invoice_no}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      }, () => {
        this.toast.show('Nie można pobrać dokumentu', 2000, 'error');
      });
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/settlements/invoices/invoices.component.ts